import { apiFetch } from './client';

/**
 * The account writes both clients send — the website's Users screen and the phone's Staff and
 * users — built once, on `bookingCommands.ts`'s terms.
 */

/**
 * Issues a one-time password and ends every session the account holds.
 *
 * <p>
 * The answer is the only time the password exists in clear anywhere — the server keeps its hash —
 * so a screen calling this must show it before anything else happens, and once.
 * </p>
 */
export function resetUserPassword(id: number) {
  return apiFetch<{ temporaryPassword: string }>(`/api/user/${id}/reset-password`, {
    method: 'POST',
  });
}
